import type { Cancelamento1056Desfecho } from '../../types/clientCancellationLines';

/** Ordem numérica de `GettelApi.Core.Enums.Cancelamento1056Desfecho` (#553). */
export const CANCELAMENTO_1056_DESFECHO_ORDINAL: Record<Cancelamento1056Desfecho, 0 | 1 | 2 | 3> = {
  ClienteCancelou: 0,
  ClienteNaoCancelou: 1,
  SemContato: 2,
  Outro: 3,
};

export const CANCELAMENTO_1056_DESFECHOS: Cancelamento1056Desfecho[] = [
  'ClienteCancelou',
  'ClienteNaoCancelou',
  'SemContato',
  'Outro',
];

export const CANCELAMENTO_1056_DESFECHO_LABELS: Record<Cancelamento1056Desfecho, string> = {
  ClienteCancelou: 'Cliente cancelou (1056)',
  ClienteNaoCancelou: 'Cliente não cancelou',
  SemContato: 'Sem contato com o cliente',
  Outro: 'Outro',
};

export function labelCancelamento1056Desfecho(value: Cancelamento1056Desfecho): string {
  return CANCELAMENTO_1056_DESFECHO_LABELS[value] ?? value;
}

/** @deprecated use labelCancelamento1056Desfecho */
export const labelOrientarCancelamento1056Desfecho = labelCancelamento1056Desfecho;

/** @deprecated use CANCELAMENTO_1056_DESFECHOS */
export const ORIENTAR_CANCELAMENTO_1056_DESFECHOS = CANCELAMENTO_1056_DESFECHOS;

/** @deprecated use Cancelamento1056Desfecho */
export type OrientarCancelamento1056Desfecho = Cancelamento1056Desfecho;

const ORDINAL_TO_DESFECHO = Object.entries(CANCELAMENTO_1056_DESFECHO_ORDINAL) as Array<
  [Cancelamento1056Desfecho, number]
>;

export function normalizarCancelamento1056Desfecho(
  raw: unknown
): Cancelamento1056Desfecho | null {
  if (raw == null || raw === '') return null;
  if (typeof raw === 'number' && Number.isInteger(raw)) {
    const found = ORDINAL_TO_DESFECHO.find(([, n]) => n === raw);
    return found ? found[0] : null;
  }
  const s = String(raw).trim();
  if ((CANCELAMENTO_1056_DESFECHOS as string[]).includes(s)) {
    return s as Cancelamento1056Desfecho;
  }
  const insensivel = CANCELAMENTO_1056_DESFECHOS.find((d) => d.toLowerCase() === s.toLowerCase());
  return insensivel ?? null;
}

/** Valor numérico do enum PosVendaProtocoloTipo na API (#553). */
export const ORIENTAR_CLIENTE_CANCELAR_1056_TIPO_ENUM_VALUE = 29;
